import svgUrl from "ni:svgr;DTKGCsfCXmOvX3VMseVYaspjqzKlqFBZL_mQOPQD2sU";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiExtractSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 2H3v12h5V9h1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v4h3.293l-1.147-1.146a.5.5 0 0 1 .708-.708l2 2a.5.5 0 0 1 0 .708l-2 2a.5.5 0 0 1-.708-.708L12.293 7H7.5A1.5 1.5 0 0 0 6 8.5v1a.5.5 0 0 1-1 0v-1A2.5 2.5 0 0 1 7.5 6H8V2Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiExtractSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiExtractSIcon)";
}